export default __webpack_public_path__ + "static/heroSectionImage-5a3e2e6962ce22521ed3fc30b1ed3bd4.png";